<template>
  <!-- <div class="box left" ref="tableScroll">
    <div class="role-title role-title-text">
      <div class="df both-side vertical">
        <text>用户列表</text>
        <custom-button
          v-if="store.state.user.user.type === 0"
          :config="{ type: 'default', text: '新增' }"
          @click="startModal(false, '')"
        />
      </div>
    </div>
    <a-table
      :data-source="tabledata"
      :columns="columns"
      :pagination="false"
      :customRow="rowClick"
      :rowClassName="
        (record, index) => (record.id === selectId ? 'table-striped' : null)
      "
      :scroll="{ x: tableScrollData.x, y: tableScrollData.y }"
      @expand="tableExpand"
      :expandedRowKeys="expandedRowKeys"
      :indentSize="10"
      rowKey="id"
    >
      <template #action="{ record }">
        <a-space>
          <custom-icon
            :config="{ type: 'add', text: '添加账户' }"
            @click="childAddUser(record)"
          />
          <custom-icon
            :config="{ type: 'edit', text: '编辑' }"
            @click="startModal(true, record)"
          />
          <custom-icon
            :config="{ type: 'delete', text: '删除' }"
            @click="doDeleteUser(record)"
          />
        </a-space>
      </template>
    </a-table>
  </div>

  <a-modal
    v-model:visible="userModal.visible"
    :title="userModal.title"
    @ok="addorEditUser"
    :okText="userModal.okText"
    :cancelText="userModal.cancelText"
    :centered="userModal.centered"
    @cancel="cancelAddUser"
  >
    <a-form
      ref="afterSaleForm"
      :model="userFormState"
      :rules="userFormRules"
      labelAlign="right"
      :labelCol="{
        span: 4,
        offset: 0,
      }"
    >
      <a-form-item name="nickName" label="昵称">
        <a-input
          v-model:value="userFormState.nickName"
          allowClear
          placeholder="请输昵称"
        ></a-input>
      </a-form-item>
      <a-form-item name="username" label="账号">
        <a-input
          v-model:value="userFormState.username"
          allowClear
          placeholder="请输入账号"
        ></a-input>
      </a-form-item>
      <a-form-item
        name="password"
        :label="userModal.title === '修改账号信息' ? '修改密码' : '登录密码'"
      >
        <a-input-password
          v-model:value="userFormState.password"
          allowClear
          placeholder="请输入登录密码"
        ></a-input-password>
      </a-form-item>
    </a-form>
  </a-modal> -->

  <structure-vue @handleSelectUser="handleSelectUser"></structure-vue>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  toRaw,
  createVNode,
  onMounted,
  nextTick,
} from "vue";
import structureVue from "@/views/personnelManagement/component/structure/index.vue";
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";
import { notice, Toast } from "@/utils";
// import { getUserList, saveOrUpdateUser, updateAfterSale, deleteUser } from '@/request/view/afterSale';
import {
  getUserList,
  deleteUser,
  saveOrUpdateUser,
} from "@/request/view/repair";
import customButton from "@/components/button/common.vue";
import customIcon from "@/components/toast/toastIcon.vue";

export default defineComponent({
  components: {
    customButton,
    customIcon,
    structureVue,
  },
  setup(props, content) {
    const store = useStore();
    const afterSaleList = reactive([]);
    const selectId = ref(0);
    const saleListPayload = reactive({
      lineNum: 10,
      pageNum: 1,
      name: "",
      total: 0,
    });
    // 表格数据
    const tabledata = reactive([]);
    // 列数据
    const columns = [
      {
        title: "昵称",
        dataIndex: "nickName",
        key: "nickName",
      },
      {
        title: "账号",
        dataIndex: "username",
        key: "username",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
        align: "center",
      },
    ];
    // 获取账号列表
    const getAfterSaleListData = () => {
      getUserList({
        // pageNum: saleListPayload.pageNum,
        // lineNum: saleListPayload.lineNum,
        // name: saleListPayload.name,
        id: store.state.user.user.id,
      }).then((res) => {
        afterSaleList.length = 0;
        tabledata.length = 0;
        if (res.code === 200 && res.message === "成功") {
          saleListPayload.total = res.data.length;
          // afterSaleList.push(...res.data.records);
          // tabledata.push(...res.data.records);
          // tabledata.push(...res.data);
        }
      });
    };
    let cacheItem = null;
    // 选择user
    const selectUser = (user) => {
      if (cacheItem === null) {
        cacheItem = user;
        cacheItem.active = true;
      } else {
        cacheItem.active = false;
        cacheItem = user;
        user.active = true;
      }
      content.emit("selectUser", user);
    };
    // 删除user
    const doDeleteUser = (user) => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(ExclamationCircleOutlined),
        content: "确定删除该账号",
        cancelText: "取消",
        centered: true,
        okText: "确定",
        okType: "primary",
        onOk() {
          deleteUser([user.id]).then((res) => {
            if (res.code === 200) {
              notice("success", "提示", res.message, 3);
              saleListPayload.pageNum = 1;
              getAfterSaleListData();
            }
          });
        },
      });
    };
    // user模态框
    const userModal = reactive({
      visible: false,
      title: "",
      cancelText: "取消",
      centered: true,
      okText: "确定",
    });
    // 关闭模态框
    const closeModal = () => {
      userModal.visible = false;
      userModal.title = "";
    };
    // 表单
    const afterSaleForm = ref();
    // 表单信息
    const userFormState = reactive({
      nickName: "",
      password: "",
      pid: store.state.user.user.id,
      username: "",
      type: null,
      id: "",
    });
    // 表单校验规则
    const userFormRules = reactive({
      nickName: [
        {
          required: true,
          message: "请输入账号名称",
          trigger: "blur",
          type: "string",
        },
      ],
      username: [
        {
          required: true,
          message: "请输入账号名称",
          trigger: "blur",
          type: "string",
        },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur",
          type: "string",
        },
      ],
    });
    let childRecord = null;
    const expandedRowKeys = ref([]);
    // 编辑设置表单值
    const setFormData = (data) => {
      userFormState.username = data.username;
      userFormState.nickName = data.nickName;
      userFormState.id = data.id;
      userFormState.pid = data.pid;
      userFormState.type = data.type;
    };
    // 打开新增用户模态框
    const startModal = (isEdit, data) => {
      userModal.visible = true;
      userModal.title = isEdit ? "修改账号信息" : "新增账号";
      //   userFormRules.password[0].required = !isEdit;
      userFormRules.password[0].required = isEdit ? false : true;
      setFormData(data);
    };
    const childAddUser = (record) => {
      childRecord = record;
      startModal(false, "");
    };
    // 用户展开
    const tableExpand = (isExpand, record) => {
      if (record.children.length === 0) {
        return Toast("warning", `${record.nickName}下无账号`, 3);
      }
      const userId = record.id;
      if (isExpand) {
        expandedRowKeys.value.push(userId);
      } else {
        const deleteIndex = expandedRowKeys.value.findIndex(
          (id) => id === userId
        );
        if (deleteIndex !== -1) {
          expandedRowKeys.value.splice(deleteIndex, 1);
        }
      }
    };
    // 重置表单
    const cancelAddUser = () => {
      userFormState.password = "";
      userFormState.username = "";
      userFormState.id = "";
      userFormState.type = null;
      userFormRules.password[0].required = true;
      childRecord = null;
      afterSaleForm.value.clearValidate();
      closeModal();
    };
    // 新增或修改user
    const addorEditUser = () => {
      afterSaleForm.value.validate().then(() => {
        if (userModal.title === "新增账号") {
          userFormState.pid =
            childRecord == null ? store.state.user.user.id : childRecord.id;

          userFormState.type =
            childRecord == null ? store.state.user.user.type : childRecord.type;
        }

        if (userFormState.password === "") {
          userFormState.password = null;
        }
        saveOrUpdateUser(toRaw(userFormState))
          .then((res) => {
            if (res.code === 200) {
              getAfterSaleListData();
              notice("success", "提示", res.message, 3);
            }
            const expandedRowKeysNoId =
              expandedRowKeys.value.findIndex(
                (id) => id === userFormState.pid
              ) === -1;
            if (userModal.title === "新增账号" && expandedRowKeysNoId) {
              expandedRowKeys.value.push(userFormState.pid);
            }
            console.log(expandedRowKeys.value);
            cancelAddUser();
          })
          .catch((err) => {
            cancelAddUser();
          });
      });
    };
    //  页码变化
    const handlePaginationChange = (page, pageSize) => {
      saleListPayload.pageNum = page;
      getAfterSaleListData();
    };

    const rowClick = (record) => {
      return {
        onclick: () => {
          selectId.value = record.id;
          selectUser(record);
        },
      };
    };

    const tableScrollData = reactive({
      x: null,
      y: null,
    });
    const tableScroll = ref();

    const setTableScollData = () => {
      nextTick(() => {
        if (tableScroll.value) {
          const domInfo = tableScroll.value.getBoundingClientRect();
          tableScrollData.x = domInfo.right - domInfo.left - 80;
          tableScrollData.y = domInfo.height - 120;
        }
      });
    };

    window.addEventListener("resize", setTableScollData);
    onMounted(() => {
      getAfterSaleListData();
      setTableScollData();
    });


    const handleSelectUser = (user) => {
      content.emit('selectUser', user);
    };

    return {
      selectId,
      handleSelectUser,
      afterSaleList,
      addorEditUser,
      selectUser,
      doDeleteUser,
      userModal,
      afterSaleForm,
      userFormState,
      cancelAddUser,
      userFormRules,
      startModal,
      columns,
      tabledata,
      saleListPayload,
      handlePaginationChange,
      rowClick,
      childAddUser,
      expandedRowKeys,
      tableExpand,
      tableScrollData,
      tableScroll,
      store,
    };
  },
});
</script>

<style lang="less" scoped>
.box {
  height: 100%;
}
.left {
  width: 900px;
  padding: 0px 16px 0px 20px;
}

.role-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.role-title {
  height: 52px;
  border-bottom: 1px solid #d8d8d8;
}

.active {
  color: #0052d9;
  background: #ecf2fc;
}

.ant-table-striped :deep(.table-striped) td {
  background-color: #cfc;
}
</style>
